import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Profile = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M22 2.515c-4.293 0-7.772 3.471-7.772 7.752 0 4.282 3.48 7.753 7.772 7.753 4.293 0 7.772-3.47 7.772-7.752S26.292 2.514 22 2.514Zm-9.873 7.752C12.127 4.83 16.547.42 22 .42c5.453 0 9.873 4.409 9.873 9.848 0 5.438-4.42 9.847-9.873 9.847-5.453 0-9.873-4.409-9.873-9.847ZM22 25.786c-6.296 0-11.4 5.09-11.4 11.37v4.023c0 .637.51 1.146 1.149 1.146h20.502c.638 0 1.148-.51 1.148-1.146v-4.023c0-6.28-5.103-11.37-11.399-11.37ZM8.5 37.156c0-7.437 6.044-13.465 13.5-13.465s13.5 6.028 13.5 13.465v4.023a3.24 3.24 0 0 1-3.249 3.24H11.749A3.24 3.24 0 0 1 8.5 41.18v-4.023Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
Profile.displayName = 'Profile';
Profile.defaultProps = {
  'aria-label': 'Profile'
};
export default Profile;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Profile.js
// module id = 3883
// module chunks = 11